import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CustomizedTable from "../../CustomizedTable/CustomizedTable";
import CarrierNameCell from "../../CustomizedTable/CustomCells/CarrierNameCell/CarrierNameCell";
import PhoneNumberCell from "../../CustomizedTable/CustomCells/PhoneNumberCell/PhoneNumberCell";
import { ActiveBoldCell, DefaultCell, UpCaseCell } from "../../CustomizedTable/CustomCells/CustomCells";

export default function GlobalSearchCarrierResults({
  searchResults,
  searchInput,
  selectedSearchType,
  handleTableAction
}) {
  const tableWidth = 1140;
  const orders = useMemo(() => searchResults, [searchResults]);
  let helpText = selectedSearchType === "carrierName" ? "Carriers" : selectedSearchType === "mcNumber" ? "MC numbers" : "DOT numbers";

  const columns = selectedSearchType === "carrierName" ? useMemo(
    () => [
      {
        Header: "Carrier",
        accessor: "name",
        filter: "fuzzyText",
        keyword: searchInput,
        width: 240,
        Cell: CarrierNameCell,
      },
      {
        Header: "Location",
        accessor: "cityState",
        filter: "fuzzyText",
        width: 160,
        Cell: UpCaseCell,
      },
      {
        Header: "MC",
        accessor: "mcNumber",
        filter: "fuzzyText",
        width: 80,
        Cell: DefaultCell,
      },
      {
        Header: "DOT",
        accessor: "dotNumber",
        filter: "fuzzyText",
        width: 80,
        Cell: DefaultCell,
      },
      {
        Header: "Phone",
        accessor: "phoneNumber",
        filter: "fuzzyText",
        width: 100,
        Cell: PhoneNumberCell,
      },
    ]
  ) : selectedSearchType === "mcNumber" ? useMemo(
    () => [
      {
        Header: "MC",
        accessor: "mcNumber",
        filter: "fuzzyText",
        keyword: searchInput,
        width: 80,
        Cell: ActiveBoldCell,
      },
      {
        Header: "Carrier",
        accessor: "name",
        filter: "fuzzyText",
        keyword: searchInput,
        width: 240,
        Cell: CarrierNameCell,
      },
      {
        Header: "Location",
        accessor: "cityState",
        filter: "fuzzyText",
        width: 160,
        Cell: UpCaseCell,
      },
      {
        Header: "DOT",
        accessor: "dotNumber",
        filter: "fuzzyText",
        width: 80,
        Cell: DefaultCell,
      },
      {
        Header: "Phone",
        accessor: "phoneNumber",
        filter: "fuzzyText",
        width: 100,
        Cell: PhoneNumberCell,
      },
    ]
  ) : useMemo(
    () => [
      {
        Header: "DOT",
        accessor: "dotNumber",
        filter: "fuzzyText",
        keyword: searchInput,
        width: 80,
        Cell: ActiveBoldCell,
      },
      {
        Header: "Carrier",
        accessor: "name",
        filter: "fuzzyText",
        keyword: searchInput,
        width: 240,
        Cell: CarrierNameCell,
      },
      {
        Header: "Location",
        accessor: "cityState",
        filter: "fuzzyText",
        width: 160,
        Cell: UpCaseCell,
      },
      {
        Header: "MC",
        accessor: "mcNumber",
        filter: "fuzzyText",
        width: 80,
        Cell: DefaultCell,
      },
      {
        Header: "Phone",
        accessor: "phoneNumber",
        filter: "fuzzyText",
        width: 100,
        Cell: PhoneNumberCell,
      },
    ]
  );

  return (
    <Box>
      <Box sx={{ margin: "20px 0", width: tableWidth }}>
        <Typography variant="h2" color="black_solid.80">
          {`${searchResults.length} ${helpText}`}
        </Typography>
      </Box>
      <CustomizedTable
        id="global-search-carrier-results"
        columns={columns}
        data={orders}
        defaultHeight={300}
        defaultWidth={tableWidth}
        actionCallback={handleTableAction}
      />
    </Box>
  );
}

GlobalSearchCarrierResults.propTypes = {
  searchResults: PropTypes.array.isRequired,
  searchInput: PropTypes.string.isRequired,
  selectedSearchType: PropTypes.string.isRequired,
  handleTableAction: PropTypes.func
};